import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

export interface BatchGenerateFullyAiDialogData {
  roleSlug: string;
  missingTopicCount?: number;
  missingMilestoneCount?: number;
}

export interface BatchGenerateFullyAiDialogResult {
  forceRegenerate: boolean;
}

@Component({
  selector: 'app-batch-generate-fully-ai-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatDialogModule, MatCheckboxModule, MatButtonModule],
  template: `
    <h2 mat-dialog-title>Generate fully AI lessons (role)</h2>
    <form [formGroup]="form" (ngSubmit)="confirm()">
      <mat-dialog-content>
        <p class="scope">Role: <strong>{{ data.roleSlug }}</strong></p>
        <p class="hint">
          Queues Haiku Bedrock batch synthesis for every skill/topic on
          <strong>active</strong> seniority profiles and <strong>active</strong> specializations.
          Chunks of 100 packs keep memory bounded. Lessons are saved as
          <strong>draft</strong> for review before publish.
        </p>
        <p class="hint" *ngIf="data.missingMilestoneCount">
          Current active-role gap: <strong>{{ data.missingMilestoneCount }}</strong> missing lesson milestone(s)
          across <strong>{{ data.missingTopicCount || 0 }}</strong> topic(s).
        </p>
        <mat-checkbox formControlName="forceRegenerate">
          Force regenerate (archive existing fully AI packs and rebuild as drafts)
        </mat-checkbox>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-button type="button" (click)="cancel()">Cancel</button>
        <button mat-flat-button color="primary" type="submit">Queue fully AI batch</button>
      </mat-dialog-actions>
    </form>
  `,
  styles: [
    `
      .scope {
        margin: 0 0 0.75rem;
      }
      .hint {
        margin: 0 0 1rem;
        color: rgba(0, 0, 0, 0.6);
        font-size: 0.875rem;
      }
    `
  ]
})
export class BatchGenerateFullyAiDialogComponent {
  private readonly dialogRef = inject(
    MatDialogRef<BatchGenerateFullyAiDialogComponent, BatchGenerateFullyAiDialogResult | undefined>
  );
  readonly data = inject<BatchGenerateFullyAiDialogData>(MAT_DIALOG_DATA);
  private readonly fb = inject(FormBuilder);

  readonly form = this.fb.nonNullable.group({
    forceRegenerate: [false]
  });

  cancel(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    this.dialogRef.close({ forceRegenerate: this.form.controls.forceRegenerate.value });
  }
}